export default __webpack_public_path__ + "static/media/Hyundai_Tucson_View1_Fix.d093535a.png";